import { takeLatest, put, select } from 'redux-saga/effects';
import { get } from '@airasia-common/libraries/http/snapRequest';
import config from '@airasia-common/libraries/config';
import ssoClient, { HEADERS } from '@airasia-common/libraries/http/ssoClient';
import genericApiSaga from '../genericApiSaga';
import { actionCreators, types } from '../../redux/user/user.meta';
import { actionCreators as analyticsActionCreators } from '../../redux/analytics/analytics.meta';
import {
  LOB_HOTEL,
  GUEST_DETAIL_PAGE,
  HOTEL_LISTING_PAGE,
  HOTEL_DETAIL_PAGE,
} from '../../redux/analytics/analytics.constants';
import { getAuthorizationHeader } from '../../helpers';
import { getFeatureFlags } from '../hotel/hotel.saga';

function* trackApiResponse(apiLabel, startTime, lob, pageId, response) {
  const responseEnd = new Date().getTime();
  if (response.status) {
    yield put(
      analyticsActionCreators.trackReceiveApiResponse({
        api: apiLabel,
        responseTime: responseEnd - startTime,
        lob: lob,
        pageId: pageId,
      })
    );
  }
}

export function* requestFavoriteMembers(action) {
  const requestStart = new Date().getTime();

  const ssoOrigin = yield ssoClient.authorize();
  const { clientId, apiKey } = ssoOrigin;
  const { userId } = action.payload;

  const authorization = yield getAuthorizationHeader();
  const headers = {
    ...authorization,
    Origin: config.REACT_APP_SSO_ORIGIN,
    [HEADERS.CLIENT_ID.toLowerCase()]: clientId,
    [HEADERS.API_KEY.toLowerCase()]: apiKey,
    [HEADERS.GA_CLIENT_ID]: config.REACT_APP_GA_CLIENT_ID,
  };

  yield genericApiSaga({
    onResponse: response =>
      trackApiResponse(
        'Favorite Members',
        requestStart,
        LOB_HOTEL,
        GUEST_DETAIL_PAGE,
        response
      ),
    completed: actionCreators.fetchFavoriteMembersCompleted,
    failed: actionCreators.fetchFavoriteMembersFailed,
    gatewayCall: () =>
      get(`um/v2/users/${userId}/favorite-members`, null, headers, {
        baseUrl: config.REACT_APP_SSO_BASE_URL,
      }),
  });
}

export function* fetchUserSubscription({ payload }) {
  const requestStart = new Date().getTime();
  const { accessToken, loyaltyId, isHotelListingPage, isWeb } = payload || {};

  const featureFlags = yield select(getFeatureFlags);

  const enableUserSubscription = isWeb
    ? featureFlags.ENABLE_USER_SUBSCRIPTION_WEB
    : featureFlags.ENABLE_USER_SUBSCRIPTION_APP;

  if (enableUserSubscription) {
    const headers = {
      Origin: config.REACT_APP_USER_SUBSCRIPTION_URL,
      [HEADERS.ACCEPT_VERSION]: 'V1',
      [HEADERS.AUTHORIZATION]: `Bearer ${accessToken}`,
    };

    yield genericApiSaga({
      onResponse: response =>
        trackApiResponse(
          'User Subscription',
          requestStart,
          LOB_HOTEL,
          isHotelListingPage ? HOTEL_LISTING_PAGE : HOTEL_DETAIL_PAGE,
          response
        ),
      completed: actionCreators.fetchUserSubscriptionCompleted,
      failed: actionCreators.fetchUserSubscriptionFailed,
      gatewayCall: () =>
        get(`has_subscriptions?loyalty_id=${loyaltyId}`, null, headers, {
          baseUrl: config.REACT_APP_USER_SUBSCRIPTION_URL,
        }),
    });
  }
}

export default function* createUserSaga() {
  yield takeLatest(types.FETCH_FAVORITE_MEMBERS, requestFavoriteMembers);
  yield takeLatest(types.FETCH_USER_SUBSCRIPTION, fetchUserSubscription);
}
